import React from 'react';
import AProgress from 'antd-mobile/lib/progress';



export default class Progress extends AProgress {}